import axios from "axios";
import toast from "react-hot-toast";

const ApiRoot = `${process.env.REACT_APP_RULES_API_ROOT}/pathway`;

export async function getAllPathwaysAsync() {
	try {
		const result = await axios.get(ApiRoot);
		return result.data;
	} catch {
		toast.error("Error listing pathways please try again");
		return [];
	}
}

export async function getPathwayByIdAsync(id) {
	try {
		const result = await axios.get(`${ApiRoot}/${id}`);
		return result.data;
	} catch {
		toast.error("Error loading pathway please try again");
		return {};
	}
}

export async function createPathwayAsync(pathway) {
	let success = true;

	try {
		const result = await axios.post(ApiRoot, pathway);
		if (result.status !== 201) success = false;
	} catch {
		success = false;
	}

	if (success) toast.success("Pathway created successfully");
	else toast.error("Error creating pathway please try again");

	return success;
}

export async function updatePathwayAsync(id, pathway) {
	let success = true;

	try {
		const result = await axios.put(`${ApiRoot}/${id}`, pathway);
		if (result.status !== 200) success = false;
	} catch {
		success = false;
	}

	if (success) toast.success("Pathway updated successfully");
	else toast.error("Error updating pathway please try again");

	return success;
}

export async function deletePathwayAsync(id) {
	let success = true;
	let isConflicted = false;
	let conflicts = [];

	try {
		const result = await axios.delete(`${ApiRoot}/${id}`);
		if (result.status !== 204) success = false;
	} catch (exception) {
		if (exception.response.status === 409) {
			isConflicted = true;
			conflicts = exception.response.data;
		}

		success = false;
	}

	if (success) toast.success("Pathway deleted successfully");
	else toast.error("Error deleting pathway please try again");

	return { success, isConflicted, conflicts };
}
